import { defineStore  } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useAllOrderStore = defineStore('all-order', {
  state: () => ({
    orders: []
  }),

  getters : {
  },
  
  actions: {
    async getAllOrders(){
      const res = await httpService.post(URL.ORDER_UNSERVED_RETRIEVE, {})
      this.orders = res
    },

    async updateServed(p){
      await httpService.post(URL.ORDER_SERVE_UPDATE, p)
      this.getAllOrders()
    },
  },
});